<template>
  <div class="dizme_tm_section" id="pricing">
    <div class="dizme_tm_services">
      <div class="container">
        <div class="dizme_tm_main_title pricing-header" data-align="center">
          <span>Pricing Plans</span>
          <h3>Choose Your <span style="color: #8067f0;">PBE</span> Journey</h3>
          <p v-if="promoActive" class="promo-banner">
            Subscription-free Pro access until October 1
          </p>
          <p>
            Whether you're just starting your preparation or looking for <span style="color: #1cbe59;">comprehensive support</span>, 
            we have the perfect plan to <span style="color: #f75023;">accelerate your success</span>
          </p>
        </div>
        <div class="service_list">
          <ul>
            <li
              class="wow fadeInLeft"
              data-wow-duration="1s"
              @click.prevent="active = 1"
            >
              <div class="list_inner tilt-effect">
                <span class="icon">
                  <img class="svg" src="/img/intro/gift.png" alt="" />
                  <img
                    class="back"
                    :src="`/img/brushes/service${dark ? '/dark' : ''}/1.png`"
                    alt=""
                  />
                </span>
                <div class="title">
                  <h3>Standard Tier</h3>
                  <span class="price-span">FREE</span>
                </div>
                <div class="">
                  <div>
                    The Standard Tier provides a wide range of preparation tools
                    and access to support the preparation of others.
                    It includes:
                    <div class="features-container">
                      <ul class="feature-list">
                        <li class="feature-item">
                          <i class="feature-icon icon-check"></i>
                          <span>Interactive First Letters</span>
                        </li>
                        <li class="feature-item">
                          <i class="feature-icon icon-check"></i>
                          <span>Chapter Drills</span>
                        </li>
                        <li class="feature-item">
                          <i class="feature-icon icon-check"></i>
                          <span>ABC Study Questions</span>
                        </li>
                        <li class="feature-item">
                          <i class="feature-icon icon-check"></i>
                          <span>5 Weekly Questions</span>
                        </li>
                        <li class="feature-item">
                          <i class="feature-icon icon-check"></i>
                          <span>Leaderboard Viewing</span>
                        </li>
                        <li class="feature-item">
                          <i class="feature-icon icon-check"></i>
                          <span>Activity Feed</span>
                        </li>
                        <li class="feature-item">
                          <i class="feature-icon icon-check"></i>
                          <span>Coach Corner</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <a class="dizme_tm_full_link" href="#"></a>
                <img
                  class="popup_service_image"
                  src="/img/service/1.jpg"
                  alt=""
                />
              </div>
            </li>
            <li
              class="wow fadeInRight"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
              @click.prevent="active = 2"
            >
              <div class="list_inner tilt-effect">
                <span class="icon">
                  <img class="svg" src="/img/intro/pro.png" alt="" />
                  <img
                    class="back"
                    :src="`/img/brushes/service${dark ? '/dark' : ''}/2.png`"
                    alt=""
                  />
                </span>
                <div class="title">
                  <h3>Pro Tier</h3>
                  <span v-if="promoActive" class="price-span">FREE until October 1</span>
                  <span v-else class="price-span">$10/mo</span>
                  <span v-if="promoActive" class="price-after">then $10/mo</span>
                </div>
                <div class="text">
                  <p v-if="promoActive">
                    Unlock MyPBE's full preparation potential. Pro is
                    <b>free until October 1</b>, then $10/month.
                  </p>
                  <p v-else>
                    Unlock MyPBE's full preparation potential with the Pro Tier
                    at just <b>$10/month</b>.
                  </p>
                  <div class="features-container">
                    <ul class="feature-list">
                      <li class="feature-item featured-item">
                        <i class="feature-icon icon-check"></i>
                        <span>All Standard Tier Features</span>
                      </li>
                      <li class="feature-item">
                        <i class="feature-icon icon-check"></i>
                        <span>Lightning Challenges</span>
                      </li>
                      <li class="feature-item">
                        <i class="feature-icon icon-check"></i>
                        <span>Assessments</span>
                      </li>
                      <li class="feature-item">
                        <i class="feature-icon icon-check"></i>
                        <span>Activity Point Tracking</span>
                      </li>
                      <li class="feature-item">
                        <i class="feature-icon icon-check"></i>
                        <span>Readiness Score Tracking</span>
                      </li>
                      <li class="feature-item">
                        <i class="feature-icon icon-check"></i>
                        <span>Leaderboard Participation</span>
                      </li>
                      <li class="feature-item">
                        <i class="feature-icon icon-check"></i>
                        <span><a href="#apps" class="feature-link" @click.stop>iPhone &amp; Android apps</a></span>
                      </li>
                    </ul>
                  </div>
                </div>
                <a class="dizme_tm_full_link" href="#"></a>
                <img
                  class="popup_service_image"
                  src="/img/service/2.jpg"
                  alt=""
                />
                <div class="service_hidden_details">
                  <div class="service_popup_informations">
                    <div class="descriptions">
                      <p>
                        Dizme is a leading web design agency with an
                        award-winning design team that creates innovative,
                        effective websites that capture your brand, improve your
                        conversion rates, and maximize your revenue to help grow
                        your business and achieve your goals.
                      </p>
                      <p>
                        In today’s digital world, your website is the first
                        interaction consumers have with your business. That's
                        why almost 95 percent of a user’s first impression
                        relates to web design. It’s also why web design services
                        can have an immense impact on your company’s bottom
                        line.
                      </p>
                      <p>
                        That’s why more companies are not only reevaluating
                        their website’s design but also partnering with Kura,
                        the web design agency that’s driven more than $2.4
                        billion in revenue for its clients. With over 50 web
                        design awards under our belt, we're confident we can
                        design a custom website that drives sales for your
                        unique business.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="wow fadeInLeft"
              data-wow-duration="1s"
              @click.prevent="active = 3"
            >
              <div class="list_inner tilt-effect">
                <span class="icon">
                  <img class="svg" src="/img/intro/badge.png" alt="" />
                  <img
                    class="back"
                    :src="`/img/brushes/service${dark ? '/dark' : ''}/3.png`"
                    alt=""
                  />
                </span>
                <div class="title">
                  <h3>Bulk Subscriptions</h3>
                  $7-8/mo
                </div>
                <div class="group-subscriptions">
                  <p>
                    Groups can save by purchasing Pro Tier access together.
                  </p>
                  <div class="features-container">
                    <ul class="feature-list">
                      <li class="feature-item">
                        <i class="feature-icon icon-check"></i>
                        <span><strong>$8/month/user</strong> for groups of 10-49 users</span>
                      </li>
                      <li class="feature-item">
                        <i class="feature-icon icon-check"></i>
                        <span><strong>$7/month/user</strong> for groups of 50+ users</span>
                      </li>
                    </ul>
                    <div class="group-access-instructions">
                      <p style="font-weight: 600; margin-bottom: 8px;">To Access Bulk Subscriptions:</p>
                      <p>1. Create a free account</p>
                      <p>2. Navigate to "Bulk Subscriptions" under "Coach Corner"</p>
                    </div>
                  </div>
                </div>
                <a class="dizme_tm_full_link" href="#"></a>
                <img
                  class="popup_service_image"
                  src="/img/service/1.jpg"
                  alt=""
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="brush_1 wow fadeInLeft" data-wow-duration="1s">
        <img src="/img/brushes/service/5.png" alt="" />
      </div>
      <div class="brush_2 wow zoomIn" data-wow-duration="1s">
        <img src="/img/brushes/service/6.png" alt="" />
      </div>
    </div>
  </div>
  <!-- <div :class="active == 1 ? '' : 'service_hidden_details'">
    <ModalBox :close="close">
      <div class="service_popup_informations">
        <div class="image">
          <img src="img/thumbs/4-2.jpg" alt="" />
          <div
            class="main"
            data-img-url="img/service/1.jpg"
            style="background-image: url('img/service/1.jpg')"
          ></div>
        </div>
        <div class="main_title">
          <h3>Creative Design</h3>
          <span class="price">Starts from <span>$99</span></span>
        </div>
        <div class="descriptions">
          <p>
            Dizme is a leading web design agency with an award-winning design
            team that creates innovative, effective websites that capture your
            brand, improve your conversion rates, and maximize your revenue to
            help grow your business and achieve your goals.
          </p>
          <p>
            In today’s digital world, your website is the first interaction
            consumers have with your business. That's why almost 95 percent of a
            user’s first impression relates to web design. It’s also why web
            design services can have an immense impact on your company’s bottom
            line.
          </p>
          <p>
            That’s why more companies are not only reevaluating their website’s
            design but also partnering with Kura, the web design agency that’s
            driven more than $2.4 billion in revenue for its clients. With over
            50 web design awards under our belt, we're confident we can design a
            custom website that drives sales for your unique business.
          </p>
        </div>
      </div>
    </ModalBox>
  </div>
  <div :class="active == 2 ? '' : 'service_hidden_details'">
    <ModalBox :close="close">
      <div class="service_popup_informations">
        <div class="image">
          <img src="img/thumbs/4-2.jpg" alt="" />
          <div
            class="main"
            data-img-url="img/service/2.jpg"
            style="background-image: url('img/service/2.jpg')"
          ></div>
        </div>
        <div class="main_title">
          <h3>Graphic Design</h3>
          <span class="price">Starts from <span>$199</span></span>
        </div>
        <div class="descriptions">
          <p>
            Dizme is a leading web design agency with an award-winning design
            team that creates innovative, effective websites that capture your
            brand, improve your conversion rates, and maximize your revenue to
            help grow your business and achieve your goals.
          </p>
          <p>
            In today’s digital world, your website is the first interaction
            consumers have with your business. That's why almost 95 percent of a
            user’s first impression relates to web design. It’s also why web
            design services can have an immense impact on your company’s bottom
            line.
          </p>
          <p>
            That’s why more companies are not only reevaluating their website’s
            design but also partnering with Kura, the web design agency that’s
            driven more than $2.4 billion in revenue for its clients. With over
            50 web design awards under our belt, we're confident we can design a
            custom website that drives sales for your unique business.
          </p>
        </div>
      </div>
    </ModalBox>
  </div>
  <div :class="active == 3 ? '' : 'service_hidden_details'">
    <ModalBox :close="close">
      <div class="service_popup_informations">
        <div class="image">
          <img src="img/thumbs/4-2.jpg" alt="" />
          <div
            class="main"
            data-img-url="img/service/3.jpg"
            style="background-image: url('img/service/3.jpg')"
          ></div>
        </div>
        <div class="main_title">
          <h3>UI/UX Design</h3>
          <span class="price">Starts from <span>$299</span></span>
        </div>
        <div class="descriptions">
          <p>
            Dizme is a leading web design agency with an award-winning design
            team that creates innovative, effective websites that capture your
            brand, improve your conversion rates, and maximize your revenue to
            help grow your business and achieve your goals.
          </p>
          <p>
            In today’s digital world, your website is the first interaction
            consumers have with your business. That's why almost 95 percent of a
            user’s first impression relates to web design. It’s also why web
            design services can have an immense impact on your company’s bottom
            line.
          </p>
          <p>
            That’s why more companies are not only reevaluating their website’s
            design but also partnering with Kura, the web design agency that’s
            driven more than $2.4 billion in revenue for its clients. With over
            50 web design awards under our belt, we're confident we can design a
            custom website that drives sales for your unique business.
          </p>
        </div>
      </div>
    </ModalBox>
  </div>
  <div :class="active == 4 ? '' : 'service_hidden_details'">
    <ModalBox :close="close">
      <div class="service_popup_informations">
        <div class="image">
          <img src="img/thumbs/4-2.jpg" alt="" />
          <div
            class="main"
            data-img-url="img/service/4.jpg"
            style="background-image: url('img/service/4.jpg')"
          ></div>
        </div>
        <div class="main_title">
          <h3>Web Design</h3>
          <span class="price">Starts from <span>$399</span></span>
        </div>
        <div class="descriptions">
          <p>
            Dizme is a leading web design agency with an award-winning design
            team that creates innovative, effective websites that capture your
            brand, improve your conversion rates, and maximize your revenue to
            help grow your business and achieve your goals.
          </p>
          <p>
            In today’s digital world, your website is the first interaction
            consumers have with your business. That's why almost 95 percent of a
            user’s first impression relates to web design. It’s also why web
            design services can have an immense impact on your company’s bottom
            line.
          </p>
          <p>
            That’s why more companies are not only reevaluating their website’s
            design but also partnering with Kura, the web design agency that’s
            driven more than $2.4 billion in revenue for its clients. With over
            50 web design awards under our belt, we're confident we can design a
            custom website that drives sales for your unique business.
          </p>
        </div>
      </div>
    </ModalBox>
  </div> -->
</template>

<script>
// import ModalBox from "./popup/ModalBox.vue";
export default {
  name: "PricingComponent",
  data() {
    return {
      active: 0,
    };
  },
  computed: {
    promoActive() {
      return new Date() < new Date(2026, 9, 1);
    },
  },
  mounted() {
    // let VanillaTilt = require("vanilla-tilt");
    // VanillaTilt.init(document.querySelectorAll(".tilt-effect"), {
    //   maxTilt: 6,
    //   easing: "cubic-bezier(.03,.98,.52,.99)",
    //   speed: 500,
    //   transition: true,
    // });
  },
  methods: {
    close() {
      this.active = 0;
    },
  },
  // components: { ModalBox },
  props: {
    dark: { type: Boolean },
  },
};
</script>

<style>
  /* Accent presets for each pricing card */
  #pricing .service_list li:nth-child(1) { --card-accent: #00D4BD; --card-accent-soft: rgba(0,212,189,0.10); }
  #pricing .service_list li:nth-child(2) { --card-accent: #fa5b0f; --card-accent-soft: rgba(250,91,15,0.10); }
  #pricing .service_list li:nth-child(3) { --card-accent: #9200ee; --card-accent-soft: rgba(146,0,238,0.10); }

  #pricing .service_list li .list_inner {
    position: relative;
    background: linear-gradient(180deg, var(--card-accent-soft, rgba(0,0,0,0.03)) 0%, rgba(255,255,255,0.95) 100%);
    border: 1px solid rgba(0,0,0,0.06);
    border-radius: 16px;
    box-shadow: 0 6px 16px rgba(0,0,0,0.06);
    transition: transform .2s ease, box-shadow .2s ease;
  }

  #pricing .service_list li .list_inner:before {
    content: "";
    position: absolute;
    inset: 0;
    border-top: 3px solid var(--card-accent, rgba(0,0,0,0.08));
    border-radius: inherit;
    pointer-events: none;
    opacity: .6;
  }

  #pricing .service_list li .list_inner:hover,
  #pricing .service_list li .list_inner:focus-within {
    transform: translateY(-4px);
    box-shadow: 0 10px 28px rgba(0,0,0,0.10);
  }

  #pricing .service_list li .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: radial-gradient(120% 120% at 50% 0%, var(--card-accent-soft, rgba(0,0,0,0.05)) 0%, rgba(255,255,255,0.9) 100%);
    box-shadow: 0 6px 18px rgba(0,0,0,0.06), 0 0 0 3px var(--card-accent-soft, rgba(0,0,0,0.05));
  }

  #pricing .service_list li .icon .svg {
    width: 28px;
    height: 28px;
    color: var(--card-accent, #f75023);
  }

  #pricing .service_list li .title h3 {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 8px;
    background: rgba(0,0,0,0.02);
  }

  body.dark #pricing .service_list li .list_inner {
    background: linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.03) 100%);
    border-color: rgba(255,255,255,0.10);
    box-shadow: 0 6px 16px rgba(0,0,0,0.25);
  }

  body.dark #pricing .service_list li .list_inner:before {
    opacity: .8;
  }

  @media (max-width: 768px) {
    #pricing .container {
      padding-left: 16px;
      padding-right: 16px;
    }

    #pricing .dizme_tm_main_title span {
      font-size: 13px;
    }

    #pricing .dizme_tm_main_title h3 {
      font-size: 22px;
      line-height: 1.3;
    }

    #pricing .service_list ul {
      display: grid;
      grid-template-columns: 1fr;
      gap: 16px;
    }

    #pricing .service_list li .list_inner {
      padding: 16px;
      border-radius: 16px;
    }

    #pricing .service_list li .icon {
      display: none !important;
    }

    #pricing .service_list li .icon .svg {
      width: 32px;
      height: 32px;
    }

    #pricing .service_list li .title h3 {
      font-size: 18px;
    }

    #pricing .service_list li .text p,
    #pricing .service_list li p {
      font-size: 14px;
      line-height: 1.6;
    }

    #pricing .popup_service_image {
      display: none;
    }

    #pricing .brush_1,
    #pricing .brush_2 {
      display: none;
    }

    .features-container {
      margin-top: 16px;
    }

    .feature-item {
      gap: 10px;
      padding: 1px 0;
    }

    .feature-icon {
      width: 16px;
      height: 16px;
    }

    .feature-icon::before {
      font-size: 10px;
    }

    .feature-item span {
      font-size: 14px;
    }

    .featured-item {
      padding: 4px 6px;
      margin: -1px -1px;
    }
  }

  @media (max-width: 480px) {
    #pricing .dizme_tm_main_title h3 {
      font-size: 20px;
    }

    #pricing .service_list ul {
      gap: 12px;
    }

    #pricing .service_list li .list_inner {
      padding: 14px;
      border-radius: 12px;
    }

    .features-container {
      margin-top: 12px;
    }

    .feature-item {
      gap: 8px;
      padding: 1px 0;
    }

    .feature-icon {
      width: 14px;
      height: 14px;
    }

    .feature-icon::before {
      font-size: 9px;
    }

    .feature-item span {
      font-size: 13px;
      line-height: 1.3;
    }

    .featured-item {
      padding: 4px 6px;
      margin: -1px -1px;
      border-radius: 6px;
    }
  }

  .price-span {
    font-size: 24px;
    font-weight: 500;
    color: #f75023;
    font-family: "Jost", sans-serif;
    display: inline-block;
    margin-bottom: 6px;
  }

  .price-after {
    display: block;
    margin: -2px 0 8px;
    font-size: 14px;
    font-weight: 600;
    color: #666;
  }

  body.dark .price-after {
    color: #c0c0c0;
  }

  .features-container {
    margin-top: 20px;
  }

  .feature-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .feature-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 2px 0;
    transition: all 0.2s ease;
  }

  .feature-item:hover {
    transform: translateX(4px);
  }

  .feature-icon {
    color: var(--card-accent, #1cbe59);
    font-size: 16px;
    font-weight: bold;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(28, 190, 89, 0.1);
    border-radius: 50%;
    position: relative;
  }

  .feature-icon::before {
    content: '✓';
    font-size: 12px;
    font-weight: 900;
    color: var(--card-accent, #1cbe59);
  }

  .feature-item span {
    font-size: 15px;
    font-weight: 500;
    color: #444;
    line-height: 1.4;
  }

  .featured-item {
    background: linear-gradient(90deg, rgba(28, 190, 89, 0.08) 0%, rgba(28, 190, 89, 0.02) 100%);
    border-radius: 8px;
    padding: 6px 10px;
    margin: -1px -2px;
  }

  .featured-item .feature-icon {
    background: rgba(28, 190, 89, 0.15);
  }

  /* Getting a link inside a pricing card to be clickable takes three things,
     because `.dizme_tm_full_link` is an absolutely positioned `z-index: 5`
     overlay across the whole card.

     1. `.feature-list` carries `position: relative; z-index: 3` from the global
        stylesheet, which makes it a *stacking context*. Nothing inside it can
        rank above 3 relative to the overlay no matter what z-index it is given,
        so the list itself is what has to clear 5.
     2. The anchor still needs to sit above its own siblings inside that list.
     3. The `@click.stop` in the template is the other half: the card's `<li>`
        handler is `@click.prevent`, which cancels this link's navigation as the
        event bubbles up.

     The overlay is an `href="#"` whose only job was opening a modal that is
     commented out, so letting the feature rows sit above it costs nothing. */
  #pricing .feature-list {
    z-index: 6;
  }

  #pricing .feature-link {
    position: relative;
    z-index: 1;
    color: #f75023;
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  .featured-item span {
    font-weight: 600;
    color: #2c2c2c;
  }

  body.dark .feature-item span {
    color: #c0c0c0;
  }

  body.dark .featured-item {
    background: linear-gradient(90deg, rgba(28, 190, 89, 0.12) 0%, rgba(28, 190, 89, 0.04) 100%);
  }

  body.dark .featured-item span {
    color: #e8e8e8;
  }

  .pricing-header {
    background: linear-gradient(135deg, rgba(102, 185, 92, 0.1) 0%, rgba(250, 91, 15, 0.1) 50%, rgba(146, 0, 238, 0.1) 100%);
    padding: 40px 20px;
    border-radius: 20px;
    margin-bottom: 40px;
    position: relative;
    overflow: hidden;
  }

  .pricing-header::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 30% 20%, rgba(102, 185, 92, 0.15) 0%, transparent 50%),
                radial-gradient(circle at 70% 80%, rgba(250, 91, 15, 0.15) 0%, transparent 50%),
                radial-gradient(circle at 50% 50%, rgba(146, 0, 238, 0.1) 0%, transparent 50%);
    z-index: -1;
  }

  .pricing-header h3 {
    margin-bottom: 20px;
  }

  .pricing-header p {
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.7;
  }

  .pricing-header .promo-banner {
    display: block;
    width: fit-content;
    max-width: 100%;
    margin: 0 auto 16px;
    padding: 10px 18px;
    border-radius: 999px;
    background: rgba(28, 190, 89, 0.14);
    color: #148a40;
    font-weight: 700;
    line-height: 1.4;
  }

  body.dark .pricing-header .promo-banner {
    background: rgba(28, 190, 89, 0.18);
    color: #7ee0a4;
  }

  @media (max-width: 768px) {
    .pricing-header {
      padding: 30px 15px;
      border-radius: 15px;
      margin-bottom: 30px;
    }

    .pricing-header h3 {
      font-size: 24px;
      margin-bottom: 15px;
    }

    .pricing-header p {
      font-size: 16px;
      line-height: 1.6;
    }
  }

  @media (max-width: 480px) {
    .pricing-header {
      padding: 25px 10px;
      border-radius: 12px;
    }

    .pricing-header h3 {
      font-size: 22px;
    }

    .pricing-header p {
      font-size: 15px;
    }
  }

  .pricing-header span {
    font-family: inherit !important;
    font-weight: inherit !important;
    font-size: inherit !important;
    font-style: inherit !important;
    text-decoration: inherit !important;
    letter-spacing: inherit !important;
    line-height: inherit !important;
  }


</style>